(ns fablo-offers.app.screens.payment
  (:require ["@chakra-ui/react" :as ch]
            ["@iconify/react" :as iconify]
            ["react-final-form" :as rff]
            ["react-icons/fa" :refer [FaCheckCircle FaExclamationTriangle]]
            [cljs-bean.core :refer [->clj]]
            [fablo-offers.app.components.app :as app]
            [fablo-offers.app.components.form :as form]
            [fablo-offers.common.components.forms :as forms]
            [fablo-offers.common.lib.hooks :as hooks]
            [fablo-offers.common.lib.i18n :as i18n]
            [fablo-offers.common.lib.routing :as routing]
            [fablo-offers.common.state :as s]
            [fablo-offers.common.tracking :as tracking :refer [track use-track get-tracking-params]]
            [reitit.frontend.easy :as rfe]
            [rumext.alpha :as mf]
            [tick.core :as tick]))

(mf/defc blik-input [{:keys [t]}]
  [:& forms/field
   {:name :blik-code
    :label (t :payment/blik-enter)
    :component forms/pin-input
    :cmp-params {:digits 6
                 :size :lg}}])

(mf/defc transfer-methods [{:keys [t methods]}]
  (let [methods (if (map? methods) (vals methods) methods)
        methods (->> methods
                     (filter :name)
                     (sort-by (comp #(.toLowerCase %) :name)))]
    [:& forms/field
     {:name :transfer-method
      :label (t :payment/choose-payment-method)
      :component ch/Select
      :cmp-params {:placeholder (t :form/choose)
                   :children (for [m methods]
                               (mf/html
                                [:option {:value (:tid m)} (:name m)]))}}]))

(mf/defc rules-text []
  [:> ch/Text {:font-size "sm"}
   [:> i18n/trans
    {:i18n-key "payment:tpay-rules"
     :components {:rules
                  (mf/html [:> ch/Link {:href "https://files.tpay.com/regulamin.pdf"
                                        :target "_blank"
                                        :color :blue.500}])
                  :full
                  (mf/html [:> ch/Link {:href "https://files.tpay.com/klauzula-informacyjna-platnik-umowa.pdf"
                                        :target "_blank"
                                        :color :blue.500}])}}]]
  #_(let [[visible set-visible] (hooks/use-state false)]
      [c/h-stack
       [c/collapse
        {:starting-height "22px"
         :in visible}
        [c/text {:font-size "sm"}
         [:> i18n/trans
          {:i18n-key "payment:tpay-rules"
           :components {:rules
                        (r/as-element [c/link {:href "https://tpay.com/user/assets/files_for_download/regulamin.pdf"
                                               :target "_blank"
                                               :color :blue.500}])}}]]]
       [c/button
        {:size "sm"
         :on-click #(set-visible (not visible))}
        [c/icon
         {:as FiChevronDown
          :font-size "xl"
          :transition-property "transform"
          :transition-duration "var(--chakra-transition-duration-normal)"
          :transform (if visible "rotate(180deg)" "rotate(0deg)")}]]]))

(defn form-validator [t]
  (forms/malli-validator t
                         [:and
                          [:map
                           [:name [:string {:min 3
                                            :error/message (t :form/enter-full-name)}]]
                           [:email [:re {:error/message (t :form/enter-email)}
                                    #"^.+?@.+\..+$"]]
                           [:tpay-method
                            [:enum {:error/fn #(t :payment/choose-payment-method)}
                             "blik" "card" "transfer"]]
                           [:blik-code {:optional true} [:re {:error/message (t :payment/blik-format-error)}
                                                         #"^$|^\d{6}$"]]
                           [:tpay-tos [:fn {:error/message (t :form/accept-rules)} true?]]]
                          [:fn
                           {:error/message (t :payment/blik-enter)
                            :error/path [:blik-code]}
                           (fn [{:keys [method blik-code]}]
                             (or (not= method "blik") (seq blik-code)))]
                          [:fn
                           {:error/message (t :payment/choose-payment-method)
                            :error/path [:transfer-method]}
                           (fn [{:keys [method transfer-method]}]
                             (or (not= method "transfer") (seq transfer-method)))]]))

(defn form-validator-2 [t]
  (forms/malli-validator t
                         [:and
                          [:map
                           [:email [:re {:error/message (t :form/enter-email)}
                                    #"^.+?@.+\..+$"]]
                           [:method [:some {:error/fn #(t :payment/choose-payment-method)}]]]]))

(mf/defc name-input-field [{:keys [t]}]
  [:& forms/field
   {:name :name
    :label (t :payment/label.full-name)
    :component ch/Input}])

(defn use-submit-payment-form [payment]
  (let [redirect! (fn [url] (set! js/window.location url))
        on-success (fn [response variables context]
                     (.setQueryData
                      s/query-client
                      (s/js-key [:screen/payment {:payment-id (:payment/id response)}])
                      (fn [x]
                        (update x :payment merge response)))
                     (track "Payment form submitted" {})
                     (when-let [url (get-in response [:redirect-url])]
                       (redirect! url)))
        on-error (fn [response]
                   (track "Error in payment form submittion" {})
                   (rfe/push-state :screen/order {:order-id (:payment/order-id payment)}))
        mutation (s/use-tx :payment/start
                           {:on-error on-error
                            :on-success on-success})

        submit (fn [values]
                 (let [method-id (if (= (:tpay-method values) "blik")
                                   150
                                   (:transfer-method values))
                       values (assoc values
                                     :method-id method-id
                                     :return-url js/window.location.href)]
                   ((:mutate mutation) values)))]

    (assoc mutation
           :submit submit)))

(def payment-in-retry-atom? (s/atom false))

(mf/defc time-left-counter [{:keys [payment]}]
  (let [due (:payment/due-date payment)
        left (mf/use-state nil)
        timeout (mf/use-state nil)
        total (* 16 60)
        seconds (or @left 0)
        m (quot seconds 60)
        s (mod seconds 60)
        left-text (str m ":" (when (< s 10) "0") s)]

    (mf/with-effect
      (letfn [(update []
                (let [duration (tick/duration
                                {:tick/beginning (tick/instant)
                                 :tick/end (tick/instant due)})
                      seconds (max 0 (tick/seconds duration))]
                  (reset! timeout (js/setTimeout update 1000))
                  (reset! left seconds)))]
        (update))
      #(js/clearTimeout @timeout))

    (when @left
      [:> ch/VStack {:mt 4 :gap 3}
       [:> ch/HStack {:gap 4}
        [:& iconify/Icon
         {:icon "material-symbols:timer"
          :color "#2E8540"
          :width 32
          :height 32}]
        [:> ch/Text
         {:color "#2E8540"
          :font-weight 600
          :font-size :3xl}
         (str left-text " min")]]
       [:> ch/Progress
        {:max total
         :value seconds
         :w "230px"
         :h "4px"
         :size :sm
         :rounded :full
         :color-scheme "green"}]]

      #_[:> ch/Tooltip
         {:label "Twój termin jest zarezerwowany przez 10 min, opłać zamówienie w tym czasie aby nie stracić rezerwacji."}
         [:> ch/Tag
          {:variant :solid
           :size :lg
           :color-scheme :yellow
           :font-weight :bold}
          @left " min"]])))

(mf/defc payment-form-1 [{{:keys [payment customer provider dispatch]} :data
                          :keys [form-submitted?]}]
  (let [{:keys [t]} (hooks/use-translation)
        {:keys [submit
                isLoading]} (use-submit-payment-form payment)
        in-retry? (s/use-atom payment-in-retry-atom?)]
    [:& forms/form
     {:on-submit (fn [values]
                   ; form-submitted? => true
                   (reset! form-submitted? true)
                   (reset! in-retry? false)
                   (submit (assoc (js->clj values :keywordize-keys true)
                                  :payment/id (:payment/id payment)))
                   js/undefined)
      :validate (form-validator t)
      :initial-values {:tpay-tos false
                       :tpay-method ""
                       :email (or (:customer/email customer) "")
                       :name (str (:customer/first-name customer) " " (:customer/last-name customer))}}

     [:> ch/VStack
      {:align "stretch"
       :gap 5}

      [:> ch/Text
       {:color :border-primary.500
        :font-weight :bold
        :text-align :center}
       (t {:pl "Twoja płatność:"
           :en "Your payment:"})]

      [:> ch/Text
       {:text-align :center}
       (:payment/description payment)
       [:br]
       (t {:pl "Kwota: " :en "Amount: "})
       [:b (:payment/amount payment) " PLN"]]

      (when (and (:payment/due-date payment)
                 (tick/< (:payment/due-date payment)
                         (tick/>> (tick/now) (tick/new-duration 30 :minutes))))
        [:> ch/Box {}
         [:> ch/Text
          {:color :border-primary.500
           :font-weight :bold
           :text-align :center}
          (t {:pl "Czas na dokonanie płatności:" :en "Time to make the payment:"})]
         [:& time-left-counter {:payment payment}]])

      [:& forms/field
       {:name :email
        :label (t :payment/label.confirmation-email)
        :component ch/Input
        :placeholder "mail@mail.pl"
        :cmp-params {:placeholder "mail@mail.pl"}}]

      [:> ch/Box
       {}
       [:& forms/field
        {:name :tpay-method
         :label (mf/html [:*
                          (t :payment/label.payment-method-with)
                          [:> ch/Image {:src "https://tpay.com/img/banners/tpay_logo_blue.svg"
                                        :h 4
                                        :vertical-align :middle
                                        :display :inline-block}]])
         :component
         (mf/fnc
          {::mf/wrap-props false}
          [field]
          [:& forms/radio-subforms
           {:props field
            :options
            [{:value "blik"
              :title (mf/html [:> ch/HStack {:justify :space-between}
                               [:> ch/Text {:font-weight :bold :font-size :lg} "BLIK"]
                               [:> ch/Image {:h 8 :src "/img/blik-logo.svg" :alt "BLIK"}]]) #_"BLIK"
              :content (mf/html [:*
                                 [:& name-input-field {:t t}]
                                 [:& blik-input {:t t}]])}
             #_{:value "card"
                :title "Karta"}
             {:value "transfer"
              :title (mf/html [:> ch/HStack {:justify :space-between}
                               [:> ch/Text {:font-weight :bold :font-size :lg} (t :payment/transfer)]
                               [:& iconify/Icon
                                {:icon "material-symbols:account-balance-rounded"
                                 :width 50
                                 :height 50}]])
              :content (mf/html [:*
                                 [:& name-input-field {:t t}]
                                 [:& transfer-methods {:t t :methods (some-> provider :tpay/payment-methods)}]])}]}])}]]

      [:& forms/field
       {:name :tpay-tos
        :type :checkbox
        :component ch/Checkbox
        :cmp-params {:py 2
                     :align-items :baseline
                     :children [(mf/html [:& rules-text {}])]}}]

      [:> ch/Button
       {:color-scheme "brand"
        :size :lg
        :w "132px"
        :m "0 auto"
        :type "submit"
        :disabled isLoading
        :box-shadow "base"}
       (t :payment/pay)]]]))

(mf/defc pay-button [{:keys [isLoading]}]
  (let [{:keys [t]} (hooks/use-translation)
        form-state (->clj (rff/useFormState))
        values (:values form-state)]
    (js/console.log "values" values)
    [:> ch/Button
     {:color-scheme "brand"
      :size :lg
      :w "148px"
      :m "30px auto 0"
      :py 4
      :height "auto"
      :type "submit"
      :white-space :pre-wrap
      :isDisabled (or isLoading (not (#{:tpay :offline} (:method values))))
      :box-shadow "base"}
     (case (:method values)
       :tpay (t :payment/pay-now)
       :offline (t :payment/pay-on-site)
       (t :payment/pay))]))

(mf/defc payment-form-2 [{{:keys [payment customer provider dispatch]} :data
                          :keys [form-submitted?]}]
  (let [{:keys [t]} (hooks/use-translation)
        {:keys [submit
                isLoading]} (use-submit-payment-form payment)
        in-retry? (s/use-atom payment-in-retry-atom?)
        allowed-methods (or (:payment/allowed-methods payment) #{:tpay :offline})
        customer (or customer (:payment/details payment))]
    [:& forms/form
     {:on-submit (fn [values]
                     ; form-submitted? => true
                   (reset! form-submitted? true)
                   (reset! in-retry? false)
                   (submit (assoc (js->clj values :keywordize-keys true)
                                  :payment/id (:payment/id payment)))
                   js/undefined)
      :validate (form-validator-2 t)
      :initial-values {:method :tpay
                       :email (or (:customer/email customer) "")
                       :name (or
                              (:customer/full-name customer)
                              (when (:customer/last-name customer)
                                (str (:customer/first-name customer) " " (:customer/last-name customer))))}}

     [:> ch/VStack
      {:align "stretch"
       :gap 5}

      [:> ch/Text
       {:color :border-primary.500
        :font-weight :bold
        :text-align :center}
       (t {:pl "Twoja płatność:"
           :en "Your payment:"})]

      [:> ch/Text
       {:text-align :center}
       (:payment/description payment) [:br]
       (t {:pl "Kwota: "
           :en "Amount due: "}) [:b (:payment/amount payment) " PLN"]]

      (when (and (:payment/due-date payment)
                 (tick/< (:payment/due-date payment)
                         (tick/>> (tick/now) (tick/new-duration 30 :minutes))))
        [:> ch/Box {:mt 4}
         [:> ch/Text
          {:color :border-primary.500
           :font-weight :bold
           :text-align :center}
          (t {:pl "Czas na dokonanie płatności:"
              :en "Time to pay:"})]
         [:& time-left-counter {:payment payment}]])

      [:& form/text
       {:name "email"
        :label (t :payment/label.confirmation-email)
        :schema [:re {:error/message (t :form/enter-email)} #"^.+?@.+\..+$"]
        :placeholder "mail@mail.pl"}]

      [:> ch/Box
       {}
       [:& form/radio-boxes-2
        {:name "method"
         :schema :some
         :label (t :payment/label.payment-method)
         :options
         (cond-> []
           (allowed-methods :tpay)
           (conj {:value :tpay
                  :content (mf/html
                            [:> ch/HStack
                             {:justify :space-around
                              :p 2
                              :border-color :border-primary.500
                              :border-width 1
                              :rounded :md
                              :text-align :center
                              :w "280px"}
                             [:> ch/Text {:font-weight 600 :font-size :md :white-space :pre-wrap :flex 1}
                              (t {:pl "Zapłać\nonline"
                                  :en "Pay\nonline"})]
                             [:> ch/Image {:w "110px" :src "https://tpay.com/img/banners/tpay_zaufane_platnosci.svg" :alt "Tpay"}]])})
           (allowed-methods :offline)
           (conj {:value :offline
                  :content (mf/html
                            [:> ch/HStack
                             {:justify :space-around
                              :p 2
                              :border-color :border-primary.500
                              :border-width 1
                              :rounded :md
                              :text-align :center
                              :w "280px"}
                             [:> ch/Text {:font-weight 600 :font-size :md :white-space :pre-wrap :flex 1}
                              (t {:pl "Zapłać\nna miejscu"
                                  :en "Pay\non site"})]
                             [:> ch/Box {:w "110px" :text-align :center}
                              [:& iconify/Icon
                               {:icon "material-symbols:universal-currency-alt-rounded"
                                :style #js {:margin "0 auto"}
                                :width 40
                                :height 40}]]])}))}]]
      [:& pay-button {:isLoading isLoading}]]]))

(mf/defc payment-form [{{:keys [payment customer provider dispatch]} :data
                        :keys [form-submitted?] :as params}]
  (if (= (:provider/id provider) "manubbies")
    [:& payment-form-1 params]
    [:& payment-form-2 params]))

(mf/defc payment-requested-section [{:keys [payment open-form disabled?]}]
  (let [t (hooks/use-t)]
    [:> ch/Box {:w :full}
     [:> ch/Button
      {:size "lg"
       :w :full
       :color-scheme :brand
       :on-click open-form
       :box-shadow :lg
       :disabled disabled?}
      (t :payment/pay)]
     (when (= :offline (:payment/method payment))
       [:> ch/Text
        {:text-align :center
         :font-size :sm
         :mt 2}
        (t {:pl "Dokonaj płatności na miejscu bądź zapłać online wcześniej."
            :en "Pay on site or pay online first."})])
     (when disabled?
       [:> ch/Text
        {:color :gray.500
         :text-align :center
         :font-size :sm}
        "Opłać najpierw wcześniejsze należności"])]))

(mf/defc payment-waiting-section [{:keys [t payment vertical?]}]
  (when vertical?
    (use-track
     (mf/deps (:payment/blik? payment))
     "Payment waiting screen"
     {"Blik?" (:payment/blik? payment)}))
  (let [in-retry? (s/use-atom payment-in-retry-atom?)]
    [:> ch/Box {}
     [:> (if vertical? ch/VStack ch/HStack)
      {:spacing 8
       :text-align :center
       :justify :center
       :py 2}
      [:> ch/Spinner
       {:color :orange.500
        :size :lg
        :thickness "4px"
        :speed "0.7s"}]
      [:> ch/Box {}
       [:> ch/Heading {:size :md :font-weight 500 :color :orange.500}
        " " (if (:payment/blik? payment)
              (t :payment/waiting-for-blik-payment)
              (t :payment/waiting-for-payment))]

       [:> ch/Text
        {:color :gray.500}
        (t {:pl "Nie zamykaj tej zakładki."
            :en "Do not close this tab."})]]]

     (when (:payment/waiting-too-long? payment)
       [:> ch/Box {}
        [:> ch/Divider {:my 2}]
        [:> ch/Text
         {:color :gray.500
          :font-size :sm
          :text-align :center}
         [:> i18n/trans
          {:i18n-key "payment:waiting-too-long"
           :components
           {:redirect (mf/html
                       [:> ch/Button
                        {:color-scheme "brand"
                         :as "a"
                         :w :full
                         :size :lg
                         :my 2
                         :href (:payment/redirect-url payment)}])
            :retry (mf/html
                    [:> ch/Link
                     {:text-decoration :underline
                      :_hover {:text-decoration :none}
                      :on-click #(reset! in-retry? true)}])}}]]])]))

(mf/defc payment-done-section [{:keys [t customer offer provider payment vertical? redirect?]}]
  (when vertical?
    (use-track "Payment done screen" {}))
  (use-track
   (mf/deps (hash payment))
   :purchase
   (get-tracking-params
    {:type :purchase
     :provider-id (:provider/id provider)
     :offer offer
     :customer customer
     :payment payment})
   (boolean (some #{:purchase} (:offer/tracking offer))))
  (mf/with-effect
    [redirect?]
    (when redirect?
      (rfe/push-state :screen/order {:order-id (:payment/order-id payment)})))
  [:> (if vertical? ch/VStack ch/HStack)
   {:spacing 4
    :text-align :center}
   [:> ch/Icon
    {:as FaCheckCircle
     :font-size 36
     :color :green.500
     :px "2px"}]
   [:> ch/Box {}
    (if-let [{:keys [header text]} (and vertical? (:thx-text payment))]
      [:> ch/Box {}
       [:> ch/Heading {:color :brand.500 :size :md :font-weight 500 :mb 4}
        (t header)]
       [:> ch/Text {:white-space :pre-wrap}
        (t text)]]

      [:> ch/Heading {:color :green.500 :size :md :font-weight 500}
       (t :payment/paid)])

    (when vertical?
      [:> ch/Button
       {:mt 16
        :color-scheme "brand"
        :as "a"
        :size :lg
        :text-transform :uppercase
        :href (routing/href :screen/order
                            {:order-id (:payment/order-id payment)})}
       "TWÓJ PANEL"])]])

(mf/defc payment-error-section [{:keys [t payment vertical?]}]
  (when vertical?
    (use-track "Payment error screen" {}))
  (let [in-retry? (s/use-atom payment-in-retry-atom?)]
    [:> (if vertical? ch/VStack ch/HStack)
     {:spacing 8
      :text-align :center
      :py 2}
     [:> ch/Icon
      {:as FaExclamationTriangle
       :font-size 40
       :color :orange.500}]
     [:> ch/Box {}
      [:> ch/Heading {:color :orange.500 :size :md :font-weight 500}
       (t :payment/payment-error)]
      [:> ch/Link {:on-click #(reset! in-retry? true)
                   :_hover {:text-decoration :none}
                   :text-decoration :underline}
       (t :payment/retry-payment)]]]))

(mf/defc payment-box [{:keys [customer offer payment provider standalone? disabled?] :as params}]
  (let [{:keys [t]} (hooks/use-translation)
        in-retry? (s/use-atom payment-in-retry-atom?)
        refreshed-status-query (s/use-query [:payment/payment-status (:payment/id payment)]
                                            {:refetch-interval 5000
                                             ;; fixme: is enabled after stasus changes from :waiting to :done
                                             :enabled (= (:payment/status payment) :waiting)})
        payment (merge payment (:data refreshed-status-query))
        status (if @in-retry?
                 :requested
                 (:payment/status payment))
        requested? (not (#{:waiting :done :error} status))
        done? (= :done status)
        error? (= :error status)
        form-opened? (mf/use-state (and (= :requested status)
                                        (:default-opened? params)))
        form-submitted? (mf/use-state false)
        waiting? (or (= :waiting status) (and requested? @form-submitted?))]

    (if standalone?
      [:> ch/Box {}
       (cond
         waiting?
         [:> ch/Box {:pt 8 :pb 16}
          [:& payment-waiting-section {:vertical? true :t t :payment payment}]]

         requested?
         [:& payment-form {:data params
                           :form-submitted? form-submitted?}]
         done?
         [:> ch/Box {:pt 8 :pb 16}
          [:& payment-done-section {:vertical? true
                                    :t t
                                    :payment payment
                                    :redirect? true
                                    :offer offer
                                    :provider provider
                                    :customer customer}]]

         error?
         [:> ch/Box {:pt 8 :pb 16}
          [:& payment-error-section {:vertical? true :t t :payment payment}]])]

      [:div
       [:> ch/Flex
        {:direction :column}
        [:> ch/Flex {:direction :column
                     :flex 1}
         [:> ch/VStack {:spacing 8 :mb 8}
          [:> ch/Box
           {:rounded :lg
            ;:bg :gray.50
            :border "1px"
            :border-color :gray.200
            :w :full
            ;:box-shadow :sm
            :p 4}
           [:> ch/VStack
            {:spacing 4}
            [:> ch/HStack
             {:w :full
              :justify :space-between
              :align :start}
             [:> ch/Box {}
              [:> ch/Text
               {:mr 4}
               (or (:payment/short-description payment) (:payment/description payment))]]
             [:> ch/Heading
              {:size :md
               :white-space :nowrap}
              (:payment/amount payment) " PLN"]]

            (when-let [due (:payment/due-date payment)]
              [:> ch/HStack
               {:w :full
                :justify :space-between
                :align :start}
               [:> ch/Box {}
                [:> ch/Text
                 {:mr 4}
                 (t {:pl "Płatność do"
                     :en "Payment due"})]]
               [:> ch/Text
                {:color :brand.500
                 :font-weight :bold
                 :white-space :nowrap}
                (.toLocaleDateString due)]])

            (when (and requested? (not waiting?))
              [:& payment-requested-section {:payment payment
                                             :open-form #(rfe/push-state :screen/payment {:payment-id (:payment/id payment)})
                                             :disabled? disabled?
                                             #_(reset! form-opened? true)}])
            (when waiting?
              [:& payment-waiting-section {:t t :payment payment}])
            (when done?
              [:& payment-done-section {:t t :payment payment :offer offer :provider provider :customer customer}])
            (when error?
              [:& payment-error-section {:t t :payment payment}])]]]]]

       [:& app/drawer
        {:is-open (and @form-opened? (not @form-submitted?))
         :on-close #(reset! form-opened? false)}
        [:> ch/Container {:p 0}
         [:& payment-form {:data params
                           :form-submitted? form-submitted?}]]]])))
